import type { RouteLocationRaw } from 'vue-router'
import type { ComputedRef, Ref } from '@/composition/vue/compositionApi'
import type { TmWrappers } from '@/wrappers'
import type { MessagesPriceSendResponseBody } from '@/services/domain/messages/types'
import type { MessengerMessageType } from '@/data/models/domain/chats/types'
import type AttachmentFile from '@/data/models/domain/attachmentFile/AttachmentFile'

export const CHAT_EDITOR_ID = 'chatEditorId' as const

export const messageDetailsModalId: TmWrappers = 'messageDetailsModal'
export const chatsNotificationsModalId: TmWrappers = 'chatsNotificationsModal'
export const chatConversationSenderSettingsModalId: TmWrappers = 'chatConversationSenderSettingsModal'

export enum AlertType {
  Close,
  Block,
  Unsubscribe,
  Error,
  Schedule,
  Warning,
  NotEnoughBalance,
  ByocPlanLimitExceed,
}

export type TAlert = {
  type: AlertType
  priority: 'high' | 'low'
  action?: () => void
  to?: () => RouteLocationRaw
  text?: Ref<string> | ComputedRef<string>
  show?: boolean
  amount?: number
  hideCloseButton?: boolean
}

export type TAlertConfig = TAlert & {
  dependsOn: Ref<boolean> | ComputedRef<boolean> | Ref<string> | Ref<number>
}

export type AIWaysToReplyRecord = {
  loading: boolean
  emoji: string
  accent: string
  text: string
  reply: string
}

export type ChatConversationSenderSettingsModalParams = {
  editingId: string
  chatId?: string
  saveCallback: () => void
}

export type VScrollComponent = {
  getScrollElement(): HTMLDivElement
  scrollTo: (to: number, how?: string) => void
  scrollToEnd: () => void
}

export type ChatEditorMessageSentParams = {
  text: string
  chatId: string
  promise: Promise<MessagesPriceSendResponseBody>
  type?: MessengerMessageType
  files?: AttachmentFile[]
}

export const enum ChatEditorWarningType {
  None = 0,
  CanSend = 1,
  Ended = 2,
  CannotRespond = 3,
  Unavailable = 4,
  NoThreads = 5,
}

export const CHAT_LEFT_SIDEBAR_WIDTH = 'chat-left-sidebar-width'
export const CHAT_RIGHT_SIDEBAR_WIDTH = 'chat-right-sidebar-width'

interface IChatEditorAttachInfo<T extends boolean> {
  isButton: T
  isDisabled: boolean
}

interface IChatEditorAttachInfoButton extends IChatEditorAttachInfo<true> {
  tooltip: string
  label: string
  clickHandler: () => void
}

interface IChatEditorAttachInfoDropdown extends IChatEditorAttachInfo<false> {
  tooltipText: string
  mediaLabel: string
  documentLabel: string
  fileLabel: string
  selectMediaHandler: () => void
  selectDocumentHandler: () => void
}

export type ChatEditorAttachInfo = IChatEditorAttachInfoButton | IChatEditorAttachInfoDropdown
